export const homeBtnMoneyHandler = {
  homeBtnMoneyHandler_deposit: "Depositar",
  homeBtnMoneyHandler_withdraw: "Retirar",
  homeBtnMoneyHandler_transfer: "Transferir",

  homeBtnMoneyHandler_balance: "Saldo actual",
};
